import { Navigate, NavLink, Route, Routes as Switch } from 'react-router-dom';

import { Tab, TabGroup } from '@servicetitan/design-system';

import { TelecomRoutes } from '../utils/routes';
import { getNavClickHandler } from '../../common/utils/get-nav-click-handler';
import { Phones } from './phones/phones';
import { GlobalOptOut } from './global-opt-out/global-opt-out';
import { OutboundMessages } from './outbound-messages/outbound-messages';
import { Tcr } from './tcr/tcr';
import { PageContentWrapper } from '../components/manage-tenant-layout/page-content-wrapper';

export const Telecom = () => {
    return (
        <PageContentWrapper title="Telecom">
            <div>
                <TabGroup className="m-b-2">
                    <NavLink to={TelecomRoutes.phones} end>
                        {({ isActive }) => (
                            <Tab active={isActive} onClick={getNavClickHandler(isActive)}>
                                Phones
                            </Tab>
                        )}
                    </NavLink>
                    <NavLink to={TelecomRoutes.globalOptOut}>
                        {({ isActive }) => (
                            <Tab active={isActive} onClick={getNavClickHandler(isActive)}>
                                Global Opt Out
                            </Tab>
                        )}
                    </NavLink>
                    <NavLink to={TelecomRoutes.outboundMessages}>
                        {({ isActive }) => (
                            <Tab active={isActive} onClick={getNavClickHandler(isActive)}>
                                Outbound Messages
                            </Tab>
                        )}
                    </NavLink>
                    <NavLink to={TelecomRoutes.tcr}>
                        {({ isActive }) => (
                            <Tab active={isActive} onClick={getNavClickHandler(isActive)}>
                                TCR
                            </Tab>
                        )}
                    </NavLink>
                </TabGroup>
                <Switch>
                    <Route path={TelecomRoutes.phones} element={<Phones />} />
                    <Route path={TelecomRoutes.globalOptOut} element={<GlobalOptOut />} />
                    <Route path={TelecomRoutes.outboundMessages} element={<OutboundMessages />} />
                    <Route path={TelecomRoutes.tcr} element={<Tcr />} />
                    <Route path="*" element={<Navigate to={TelecomRoutes.phones} replace />} />
                </Switch>
            </div>
        </PageContentWrapper>
    );
};
